const style = {
  minimapContainer: (minimapWidth, minimapHeight) => ({
    position: 'absolute',
    top: '10px',
    right: '10px',
    width: `${minimapWidth + 30}px`,
    height: `${minimapHeight}px`,
    zIndex: '10',
    display: 'flex',
    flexDirection: 'row',
  }),
  pointer: (pointerWidth, pointerHeight, pointerPositionX, pointerPositionY) => ({
    position: 'absolute',
    width: `${Math.max(0, Math.min(pointerWidth || 1, 1)) * 100}%`,
    height: `${Math.max(0, Math.min(pointerHeight || 1, 1)) * 100}%`,
    boxSizing: 'border-box',
    boxShadow: 'inset 0px 0px 0px 1px red',
    left: `${Math.max(0, Math.min(pointerPositionX || 0, 1)) * 100}%`,
    top: `${Math.max(0, Math.min(pointerPositionY || 0, 1)) * 100}%`,
    zIndex: '10',
    cursor: ['pointer', 'hand', '-webkit-grab', 'grab'],
  }),
  imageShadow: (initialImageWidth, initialImageHeight) => ({
    display: 'flex',
    width: `${initialImageWidth}px`,
    height: `${initialImageHeight}px`,
    background: 'rgba(0,0,0,0.5)',
    position: 'relative',
  }),
  zoomWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    flex: 1,
  },
  zoomButton: {
    fontSize: '14px',
    cursor: 'pointer',
  },
};

export default style;



// WEBPACK FOOTER //
// ./src/components/Map/Minimap/Minimap.styles.js